import { DateCalendar, DateCalendarProps, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { startOfDay } from "date-fns";
import { ForwardedRef, forwardRef, useState } from "react";
import { CustomPickerDay } from "./CustomPickerDay";

type MultiDatePickerCalendarProps = DateCalendarProps<Date> & {
  onChange: (dates: Date[]) => void;
  id?: string;
};
// implementation extended from https://mui.com/x/react-date-pickers/date-calendar/#dynamic-data
export const MultiDatePickerCalendar = forwardRef(
  (props: MultiDatePickerCalendarProps, ref: ForwardedRef<HTMLDivElement>) => {
    const [highlightedDays, setHighlightedDates] = useState<Date[]>([]);
    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateCalendar
          {...props}
          ref={ref}
          value={highlightedDays[0] ?? null}
          onChange={(value) => {
            if (!value) {
              return;
            }
            setHighlightedDates((previousHighlightedDays) => {
              const currentCalendarDay = startOfDay(value);
              const currentHighlightedDays = [...previousHighlightedDays];

              // if current date is already selected, remove it from the list, else add it
              const isCurrentCalendarDayHighlighted = currentHighlightedDays.some((date) => {
                return date.toDateString() === currentCalendarDay.toDateString();
              });
              if (isCurrentCalendarDayHighlighted) {
                currentHighlightedDays.splice(
                  currentHighlightedDays.findIndex((date) => {
                    return date.toDateString() === currentCalendarDay.toDateString();
                  }),
                  1
                );
              } else {
                // sort the dates in ascending order since the component does not guarantee the order
                currentHighlightedDays.push(currentCalendarDay);
                currentHighlightedDays.sort((a, b) => a.getTime() - b.getTime());
              }
              props.onChange(currentHighlightedDays);
              return currentHighlightedDays;
            });
          }}
          slots={{
            // The component needs to be defined outside or will loose state on re-renders, refer issue: https://github.com/mui/mui-x/issues/8596#issuecomment-1511241504
            day: CustomPickerDay,
          }}
          slotProps={{ day: { selectedDays: highlightedDays } as never }}
        />
      </LocalizationProvider>
    );
  }
);
